import { create } from 'zustand';
import type { Me } from '../api/types';

/** 'loading' = /api/me not yet resolved (don't redirect or render gated content
 * until it settles); 'authed' = identity known; 'anon' = no/invalid session. */
export type AuthStatus = 'loading' | 'authed' | 'anon';

interface AuthState {
  me: Me | null;
  status: AuthStatus;
  setMe: (me: Me | null) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  me: null,
  status: 'loading',
  setMe: (me) => set({ me, status: me ? 'authed' : 'anon' }),
  clear: () => set({ me: null, status: 'anon' }),
}));
